jQuery(document).ready(function ($) {
    // 1. Respect user choice
    if (localStorage.getItem("language")) return;

    var country = Shopify.country;
    var isDefaultLanguage = "de";
    var currentLocale = Shopify.locale;

    // 2. German-speaking countries
    var germanCountries = ["DE", "AT", "CH", "LI", "LU", "GB"];

    var path = window.location.pathname;

    // 3. Switch only if NOT German-speaking
    console.log(country, germanCountries, isDefaultLanguage, currentLocale, germanCountries.includes(country));
    if (isDefaultLanguage && currentLocale === "de" && !germanCountries.includes(country)) {
        console.log("/en" + path + window.location.search);
        window.location.href = "/en" + path + window.location.search;
    }else{
        console.log("Not Redirected");
    }
});